import { defineRule, configure } from 'vee-validate';
import { all as AllRules } from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
import en from '@vee-validate/i18n/dist/locale/en.json';

export function initValidation() {

  configure({
    generateMessage: localize({
      en
    }),
  });

  Object.keys(AllRules).forEach(rule => {
    defineRule(rule, AllRules[rule]);
  });

  defineRule('positiveInteger', value => {
    return value == '' || /^[1-9][0-9]*$/.test(value)
  })

  defineRule('lengthLessThan', (value, [targetValue]) => {
    if (targetValue) {
      if (+value > +targetValue) {
        return 'Should be less or equal to maximum number of characters'
      }
    }
    return true
  })

  defineRule('valueLessThan', (value, [targetValue]) => {
    if (targetValue) {
      if (+value > +targetValue) {
        return 'Should be less or equal to maximum value'
      }
    }
    return true
  })

  defineRule('decimal', value => {
    return value == '' || /^(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/.test(value)
  })
} 